import { DirectUpload } from "@rails/activestorage";

const DIRECT_UPLOAD_URL = "/rails/active_storage/direct_uploads";

class AuthenticatedUploadDelegate {
  private onProgress?: (percent: number) => void;

  constructor(onProgress?: (percent: number) => void) {
    this.onProgress = onProgress;
  }

  directUploadWillCreateBlobWithXHR(xhr: XMLHttpRequest) {
    const token = localStorage.getItem("auth_token");
    if (token) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    }
  }

  directUploadWillStoreFileWithXHR(xhr: XMLHttpRequest) {
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable && this.onProgress) {
        this.onProgress((event.loaded / event.total) * 100);
      }
    });
  }
}

export function uploadFile(
  file: File,
  onProgress?: (percent: number) => void
): Promise<string> {
  return new Promise((resolve, reject) => {
    const delegate = new AuthenticatedUploadDelegate(onProgress);
    const upload = new DirectUpload(file, DIRECT_UPLOAD_URL, delegate);

    upload.create((error, blob) => {
      if (error) {
        reject(error);
      } else {
        resolve(blob.signed_id);
      }
    });
  });
}

export async function uploadFiles(
  files: File[],
  onProgress?: (percent: number) => void
): Promise<string[]> {
  let completed = 0;
  const total = files.length;

  const promises = files.map((file) =>
    uploadFile(file, () => {
      completed++;
      onProgress?.((completed / total) * 100);
    })
  );

  return Promise.all(promises);
}
